import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  a.vjs-control.vjs-cloudinary-button.vjs-button {
    display: none !important;
  }
`;

export const ErrorContainer = styled.div`
  color: ${p => p.theme.colors.text.secondary};
  background-color: ${p => p.theme.colors.background.tertiary};
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  width: 100%;
  padding: 12px 16px;
`;
